import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fab fa-telegram q-mt-none q-mr-none",
  style: {"color":"#2fb2ff !important"}
}
const _hoisted_2 = {
  key: 1,
  class: "fab fa-skype q-mt-none q-mr-none",
  style: {"color":"#2fb2ff !important"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "q-mt-none q-ml-xs",
  style: {"height":"40px"}
}, "@", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SignUpBackground = _resolveComponent("SignUpBackground")!
  const _component_SignUpHeader = _resolveComponent("SignUpHeader")!
  const _component_SignUpContentHeader = _resolveComponent("SignUpContentHeader")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_page = _resolveComponent("q-page")!
  const _component_q_page_container = _resolveComponent("q-page-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SignUpBackground),
    _createVNode(_component_q_page_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_SignUpHeader),
        _createVNode(_component_q_page, { class: "q-layout-container column justify-center items-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_form, {
              onSubmit: _ctx.submit,
              class: "sign-form column"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SignUpContentHeader),
                _createVNode(_component_q_input, {
                  outlined: "",
                  "stack-label": "",
                  "bg-color": "white",
                  dense: "",
                  onFocus: _ctx.resetErrors,
                  label: _ctx.$t('email_address'),
                  modelValue: _ctx.email,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                  type: "email",
                  error: _ctx.signUpError
                }, null, 8, ["onFocus", "label", "modelValue", "error"]),
                _createVNode(_component_q_input, {
                  outlined: "",
                  label: _ctx.$t('password'),
                  "stack-label": "",
                  "bg-color": "white",
                  dense: "",
                  onFocus: _ctx.resetErrors,
                  error: _ctx.signUpError,
                  modelValue: _ctx.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                  type: "password",
                  "error-message": _ctx.$t(_ctx.signUpErrorMessage)
                }, null, 8, ["label", "onFocus", "error", "modelValue", "error-message"]),
                _createVNode(_component_q_select, {
                  outlined: "",
                  dense: "",
                  "bg-color": "white",
                  onFocus: _ctx.resetErrors,
                  modelValue: _ctx.selectedMessenger,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedMessenger) = $event)),
                  options: _ctx.messengers,
                  "option-value": "id",
                  "option-label": "name",
                  "emit-value": "",
                  "map-options": "",
                  error: _ctx.signUpError
                }, {
                  prepend: _withCtx(() => [
                    (_ctx.selectedMessenger === _ctx.messengers[0].id)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_1))
                      : _createCommentVNode("", true),
                    (_ctx.selectedMessenger === _ctx.messengers[1].id)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_2))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["onFocus", "modelValue", "options", "error"]),
                _createVNode(_component_q_input, {
                  class: "q-mb-lg",
                  outlined: "",
                  label: 
            _ctx.selectedMessenger === _ctx.messengers[0].id
              ? _ctx.$t('telegram_nick')
              : _ctx.$t('skype_nick')
          ,
                  modelValue: _ctx.telegram,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.telegram) = $event)),
                  dense: "",
                  "stack-label": "",
                  "bg-color": "white"
                }, {
                  prepend: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["label", "modelValue"]),
                _createVNode(_component_q_select, {
                  dense: "",
                  "bg-color": "white",
                  label: _ctx.$t('base_currency'),
                  outlined: "",
                  class: "q-mb-lg",
                  modelValue: _ctx.baseCurrency,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.baseCurrency) = $event)),
                  options: _ctx.currencies,
                  "option-value": "id",
                  "option-label": "name",
                  "emit-value": "",
                  "map-options": ""
                }, null, 8, ["label", "modelValue", "options"]),
                _createVNode(_component_q_btn, {
                  class: "q-btn__main-size text-weight-bold q-mb-lg",
                  "no-caps": "",
                  unelevated: "",
                  label: _ctx.$t('onreg'),
                  type: "submit",
                  color: "primary",
                  loading: _ctx.loading,
                  rounded: ""
                }, null, 8, ["label", "loading"])
              ]),
              _: 1
            }, 8, ["onSubmit"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}